import React from 'react';
import { useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import ModalComponent from '../../../../../components/common-components/modal/ModalComponent';
import Icons from '../../../../../components/icons/Icons';
import Button from '../../../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../../../components/common-components/button/Constants';
import Input from '../../../../../components/common-components/input/Input';
import { getValidationSchema } from '../../../../../libs/formsUtils';
import { MASTER_MEDICATION_EDIT_FIELDS } from '../master-allergy/constant';
import { updateMasterMedication } from './MasterMedicationSaga';

function MasterEditMedicationModel({data, open, close, }) {    
    const dispatch = useDispatch();
    const fields = [
        {
            fieldName: MASTER_MEDICATION_EDIT_FIELDS.NAME,
            isRequired: true,
        },
        {
            fieldName: MASTER_MEDICATION_EDIT_FIELDS.TYPE,
            isRequired: true,
        },
        ];

    const validationSchema = getValidationSchema(fields)

    return (
        <Formik
            initialValues={
                {
                    [MASTER_MEDICATION_EDIT_FIELDS.NAME]: data?.name,
                    [MASTER_MEDICATION_EDIT_FIELDS.TYPE]: data?.type,

                }
            }
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(values) => {
                const payload = {
                    apiPayload: {
                        ...values,
                    },
                    id: data?.uuid,
                    closeEditModal: close,
                    
                };                
                try {
                    dispatch(updateMasterMedication(payload));
                } catch (err) {
                    console.log(err);
                }
            }}
        >
            {({ submitForm, isSubmitting, handleReset, values, setFieldValue, handleSubmit }) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <ModalComponent
                            open={open}
                            title={ 'Edit Medication'}
                            close={() => {
                                close();
                            }}
                            icon={<Icons iconName="closeIcon" />}
                            footerButton={
                                <Button
                                    type="submit"
                                    variant={BUTTON_VARIANTS.CONTAINED}
                                    customBtnClass="text-met-primary"
                                >
                                    Save
                                </Button>
                            }
                            customClasses="w-[60%] overflow-visible"
                            enableReinitialize
                            hideOverflow={true}
                        >
                            <div className="flex flex-col">
                                <div className="w-full flex justify-between">
                                    <div className="w-[47%]">
                                        <Input
                                            label="Name"
                                            isRequired={true}
                                            placeholder="Enter Name"
                                            name={MASTER_MEDICATION_EDIT_FIELDS.NAME}
                                            value={values[MASTER_MEDICATION_EDIT_FIELDS.NAME]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_MEDICATION_EDIT_FIELDS.NAME, e.target.value);
                                            }}
                                        />
                                    </div>
                                     <div className="w-[47%]">
                                        <Input
                                            label="Type"
                                            isRequired={true}
                                            placeholder="Enter Type"
                                            name={MASTER_MEDICATION_EDIT_FIELDS.TYPE}
                                            value={values[MASTER_MEDICATION_EDIT_FIELDS.TYPE]}
                                            onChangeCb={(e) => {
                                                setFieldValue(MASTER_MEDICATION_EDIT_FIELDS.TYPE, e.target.value);
                                            }}
                                        />
                                    </div>
                                     
                                </div>
                            </div>
                        </ModalComponent>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default MasterEditMedicationModel;
